import { Box, Column, Modal, type ModalProps } from '@viewup/ui';
import { AutoEarningSettingButton } from './AutoEarningSettingButton';
import { ViewingCampaignButton } from './ViewingCampaignButton';
import { ViewpleSettingButton } from './ViewpleSettingButton';

interface OffViewingModalProps extends Pick<ModalProps, 'isOpen' | 'exitHandler'> {}
export const OffViewingModal = (props: OffViewingModalProps) => {
  const { isOpen, exitHandler } = props;

  return (
    <Modal exitHandler={exitHandler} isOpen={isOpen} title={'보너스 뷰업'}>
      <Column gap={16}>
        {/* AccountMenuButton은 rest props를 DOM에 뿌리지 않아 Box로 감싸 앵커를 준다 */}
        <Box data-tour='bonus-viewing-campaign'>
          <ViewingCampaignButton />
        </Box>
        <Box data-tour='bonus-viewple'>
          <ViewpleSettingButton />
        </Box>
        <Box data-tour='bonus-auto-earning'>
          <AutoEarningSettingButton />
        </Box>
      </Column>
    </Modal>
  );
};
